<template>
	<div class="prop-map-info-element">
		<div class="maps-icon-cont" :class="iconBackgroundColor">
			<img :src="'/image-icons/' + mapIconName" alt="" />
		</div>
		<div class="map-card-info">
			<div class="map-card-text">{{ mapInfoValue }}</div>
			<div class="header6">{{ mapInfoLabel }}</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "prop-map-info-element",
	props: {
		mapInfoValue: String,
		mapInfoLabel: String,
		mapIconName: String,
		iconBackgroundColor: String,
	},
	data() {
		return {
			value: "",
		};
	},
	methods: {},
};
</script>

<style scoped lang="scss">
.prop-map-info-element {
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	// width: 205px;
	padding-left: 10px;
	padding-right: 10px;
	.map-card-text {
		font-weight: 400;
		font-size: 36px;
		line-height: 36px;
		color: var(--primary);
	}
	.maps-icon-cont {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	.map-card-info {
		margin-left: 20px;
	}
}
</style>